// @ts-nocheck
import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    getCategoriesRequest: ['params'],
    getCategoriesSuccess: ['payload'],
    getCategoriesFailure: null,
    createCategoryRequest: ['payload', 'data'],
    createCategorySuccess: ['payload'],
    createCategoryFailure: null,
    editCategory: ['payload'],
    updateCategoryRequest: ['params', 'payload'],
    updateCategorySuccess: ['payload'],
    updateCategoryFailure: null,
    deleteCategoryRequest: ['params'],
    deleteCategorySuccess: ['payload'],
    deleteCategoryFailure: null,
    openCategoryDrawer: ['payload'],
    closeCategoryDrawer: null,
    updateFormField: ['payload'],
    resetFormFields: null,

    createSubCategoryRequest: ['payload', 'data'],
    createSubCategorySuccess: ['payload'],
    createSubCategoryFailure: null,
    editSubCategory: ['payload'],
    updateSubCategoryRequest: ['params', 'payload'],
    updateSubCategorySuccess: ['payload'],
    updateSubCategoryFailure: null,
    deleteSubCategorySuccess: ['payload'],
    deleteSubCategoryRequest: ['params'],
    deleteSubCategoryFailure: null,
    openSubCategoryDrawer: ['payload'],
    closeSubCategoryDrawer: null,
    updateSubCategoryFormField: ['payload'],
    resetSubCategoryFormFields: ['payload'],
    openConfirmationModal: ['payload'],
    closeConfirmationModal: null,
    updateSearchText: ['payload'],
    updatePageNumber: ['payload'],
    updatePerPage: ['payload'],
    openNoteModal: ['payload'],
    closeNoteModal: null,
    updateNoteMessage: ['payload'],
    createNoteRequest: ['payload'],
    createNoteSuccess: ['payload'],
    createNoteFailure: ['payload'],
    editNote: ['payload'],
    updateNoteRequest: ['params', 'payload'],
    updateNoteSuccess: ['payload'],
    updateNoteFailure: null,
    deleteNoteRequest: ['params'],
    deleteNoteSuccess: ['payload'],
    deleteNoteFailure: null,
  },
  { prefix: 'CATEGORY/' },
);

export default Creators;
